export const CreditCardBrands = {
  VISA: 'VISA',
  MA: 'MA',
  AMEX: 'AMEX',
  DISC: 'DISC',
  HDCOM: 'HDCOM',
  HDCON: 'HDCON',
  PROP: 'PROP',
  PROX: 'PROX',
  HDMC: 'HDMC',
  CA_PROX: 'PROX',
  CA_HDCON: 'HDCON',
  CA_HDCOM: 'HDCOM',
} as const;
